<template>
  <div class="w-96" @click.stop="show = true" v-click-outside="hide">
    <label id="listbox-label" class="block text-sm font-medium text-gray-700">
      Category
      <span v-if="category" class="text-gray-600 ml-1">(id: {{ category.id }})</span>
    </label>
    <div class="relative mt-2">
      <button type="button" class="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary sm:text-sm" aria-haspopup="listbox" aria-expanded="true" aria-labelledby="listbox-label">
        <span class="block truncate" :class="loading && 'ske'"> {{ (category &&  category.name) || "ast ash asht a" }} </span>
          <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </span>
      </button>

      <transition
        enter-class="mt-1 opacity-0"
        leave-class="mt-0 opacity-100"
        enter-to-class="mt-0 opacity-100"
        leave-to-class="mt-1 opacity-0"
      >
        <div v-if="show && !loading" class="disable-ske duration-200 absolute w-full left-0 top-full mt-1 bg-white rounded-lg shadow-lg border border-gray-200">
          <ul role="list" class="py-4 overflow-auto max-h-[40em] divide-y divide-gray-100">
            <CategoryOption
              v-for="cat in categories"
              :key="cat.id"

              v-bind="cat"
              @select="targetId => $emit('select', targetId)"
            />
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>

import CategoryOption from "./CategoryOption.vue"

export default {
  props: ['category', 'categories', 'loading'],
  components: {
    CategoryOption,
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    hide() {
      this.show = false
    },
  },
}

</script>
